<script setup lang="ts">
  import { ref } from 'vue';
	import { useFeedbackFormStore } from '~/stores/FeedbackFormStore';
  import { required, minLength } from '@vuelidate/validators';
  import { useVuelidate } from '@vuelidate/core';
  import { useSettingsStore } from '~/stores/SettingsStore';

  const feedback = useFeedbackFormStore();
  const { $toast } = useNuxtApp();
  const loading = ref(false)
  const settingsStore = useSettingsStore();

  const clientInfo = ref({
    clientPhone: '',
    clientName: '',
    clientComment: '',
  });

  const rules = computed(() => {
    return {
      clientPhone: { required, minLength: minLength(10) },
      clientName: { required, minLength: minLength(2) },
      clientComment: { required, minLength: minLength(4) },
    };
  });

  const v$ = useVuelidate(rules, clientInfo);

  const submit = async () => {
    v$.value.$validate();
    if (!v$.value.$error) {
      loading.value = true;
      await feedback.send(clientInfo);
      loading.value = false;
      clientInfo.value.clientPhone = '';
      clientInfo.value.clientName = '';
      clientInfo.value.clientComment = '';
      v$.value.$reset();
      if (window && window.ym) {
        window.ym(99787939,'reachGoal','form_callback_new');
      }
      $toast.success('Форма успешно отправлена')
    } else {
      $toast.error('Заполните форму корректно')
    }
  };
</script>

<template>
  <div class="feedback-form">
    <div class="feedback-form__title title">Форма обратной связи</div>
    <div class="feedback-form__content">
      <div class="feedback-form__form">
        <div class="form-block__box">
          <div class="form-block__field">
            <vue-tel-input
              v-model="clientInfo.clientPhone"
              class="form-control form-control-small"
              placeholder="Номер телефона"
              :class="{'form-control-error': feedback.errors.includes('data.clientPhone') || v$.clientPhone.$error}"
            ></vue-tel-input>
          </div>
          <div class="form-block__field">
            <input
              type="text"
              placeholder="Ваше имя"
              class="form-control form-control-small"
              v-model="clientInfo.clientName"
              :class="{'form-control-error': feedback.errors.includes('data.clientName') || v$.clientName.$error}"
            >
          </div>
          <div class="form-block__field">
            <textarea
              name=""
              id=""
              cols="30"
              rows="10"
              placeholder="Ваше сообщение"
              class="form-control form-textarea"
              v-model="clientInfo.clientComment"
              :class="{'form-control-error': feedback.errors.includes('data.clientComment') || v$.clientComment.$error}"
            ></textarea>
          </div>
        </div>
        <div class="feedback-form__row">
          <div class="feedback-form__button">
            <button class="button button-accent" @click="submit" v-if="!loading">Отправить</button>
            <button class="button button-accent" v-else>Отправляем...</button>
          </div>
        </div>
      </div>
      <div class="feedback-form__details">
        <div class="order-form__phone">
          <a href="tel:+74957779930" class="order-form__phone-link">{{ settingsStore.phone }}</a>
        </div>
        <div class="order-form__socials">
          <div class="order-form__text">Задать вопрос в мессенджерах</div>
          <div class="order-form__socials-content">
            <a v-if="settingsStore && settingsStore.links && settingsStore.links.viber_url" :href="`${settingsStore.links.viber_url}`" target="_blank" class="order-form__socials-item order-form__socials-item--viber"></a>
            <a href="https://t.me/mycarrental_support_bot" target="_blank" class="order-form__socials-item order-form__socials-item--telegram"></a>
            <a href="https://api.whatsapp.com/send/?phone=79952260541&text&type=phone_number&app_absent=0" target="_blank" class="order-form__socials-item order-form__socials-item--whatsapp"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>